const API_BASE=process.env.REACT_APP_API_BASE_URL||'';
async function request(path,{token,body,method='GET',signal}={}) {
  const res=await fetch(`${API_BASE}/api/marketing/${path}`,{method,signal,
    headers:{...(token?{Authorization:`Bearer ${token}`}:{ }),...(body?{'Content-Type':'application/json'}:{})},
    ...(body?{body:JSON.stringify(body)}:{})});
  const data=await res.json().catch(()=>({}));
  if(!res.ok) throw new Error(data.error||'Preferenze non disponibili');
  return data;
}
function validate(data) {
  if(typeof data?.notice?.approved!=='boolean'||typeof data?.notice?.version!=='string'
    ||!['email','push'].every(channel=>typeof data?.preferences?.[channel]?.enabled==='boolean'
      &&Number.isSafeInteger(data.preferences[channel].revision))) throw new Error('Preferenze non disponibili');
  return data;
}
export const getMarketingPreferences=async(token,signal)=>validate(await request('preferences',{token,signal}));
export const saveMarketingPreference=async(token,body)=>validate(await request('preferences',{token,body,method:'PUT'}));
export const unsubscribeMarketing=token=>request('unsubscribe',{body:{token},method:'POST'});
export const getMarketingNotice=signal=>request('notice',{signal});
export const claimMarketingNotice=token=>request('notice/claim',{token,body:{},method:'POST'});
